'use client'
import { Loader2 } from 'lucide-react'
import { lazy, Suspense, useEffect, useRef, useState } from 'react'

import styles from './raycast.module.css'

const CommandMenu = lazy(() => import('./cmdk'))

function CommandMenuContainer() {
  const [open, setOpen] = useState(false)

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  const containerEle = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <div ref={containerEle} className={styles.raycast} />
      {open && (
        <Suspense
          fallback={
            <div className="fixed inset-0 flex h-screen w-screen items-center justify-center bg-black/20 z-30 backdrop-blur-lg">
              <Loader2 className="animate-spin" />
            </div>
          }
        >
          <CommandMenu open={open} setOpen={setOpen} container={containerEle.current} />
        </Suspense>
      )}
    </>
  )
}

export default CommandMenuContainer
